<template>
  <div :class="{ hidden: hidden }" class="pagination-container">
    <!-- <el-button
      @click="downScv(tableData, column)"
      size="small"
      :disabled="tableData.length == 0"
      >Data download</el-button
    > -->
    <el-pagination
      :background="background"
      :current-page.sync="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <!-- :class="device!=='mobile'?'':'model'" -->
  </div>
</template>

<script>
// import { scrollTo } from '@/utils/scroll-to'
// import { mapGetters } from 'vuex'
export default {
  name: "Pagination",
  props: {
    total: {
      required: true,
      type: Number,
    },
    page: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 20,
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50, 100];
      },
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
    background: {
      type: Boolean,
      default: true,
    },
    /* tableData: {
      required: true,
      type: Array,
    },
    column: {
      required: true,
      type: Array,
    }, */
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /*  ...mapGetters([
      
      'device'
    ]), */
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      },
    },
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit("update:limit", val);
      },
    },
  },
  methods: {
    handleSizeChange(val) {
      this.$emit("pagination", { page: this.currentPage, limit: val });
      /* if (this.autoScroll) {
        scrollTo(0, 800);
      } */
    },
    handleCurrentChange(val) {
      this.$emit("pagination", { page: val, limit: this.pageSize });
      /*  if (this.autoScroll) {
        scrollTo(0, 800);
      } */
    },
    downScv(data, column) {
      var newColumn = [];
      for (var i = 0; i < column.length; i++) {
        newColumn.push(column[i].label);
      }
      var scv_header = newColumn.join("\t");
      let scv = `${scv_header}\n`;
      var arr = [];
      for (let i = 0; i < data.length; i++) {
        arr[i] = [];
        for (var a = 0; a < newColumn.length; a++) {
          arr[i].push(data[i][newColumn[a]]);
        }
      }
      var tableData = [];
      tableData = tableData.concat([newColumn], arr);
      ExportUtil.toExcel(tableData, Date.now() + ".xls");
    },
  },
};
</script>

<style scoped>
.pagination-container {
  background: #fff;
  padding: 10px 0px;
  display: flex;
}
.pagination-container.hidden {
  display: none;
}
.model {
  display: grid;
}
.pagination-container .el-pagination>>>.el-pagination__sizes .el-input__inner {
  padding-right: 10px !important;
}
.pagination-container .el-pagination>>>.el-pagination__sizes .el-input__suffix {
  display: none;
}
</style>
